import { makeStyles } from '@material-ui/core';
import NeutralSVG from 'assets/images/neutral.svg';
import React, { ReactElement } from 'react';

const useStyles = makeStyles(() => ({
  logo: {
    width: '24px',
    height: '24px',
    objectFit: 'cover',
  },
}));

function Neutral(): ReactElement {
  const classes: any = useStyles();
  return <img src={NeutralSVG} alt="Neutral icon" className={classes.logo} />;
}

export default Neutral;
